// services/StudentAttemptService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

// Suivi (lecture) des tentatives - réservé ADMIN/TEACHER
export function getAttempts(params = {}) {
    return api.get(ENDPOINTS.ATTEMPTS.BASE, { params });
}
export function getAttemptById(id) {
    return api.get(ENDPOINTS.ATTEMPTS.BY_ID(id));
}
export function getAttemptAnswers(id) {
    return api.get(ENDPOINTS.ATTEMPTS.ANSWERS(id));
}
export function cancelAttempt(id) {
    return api.post(ENDPOINTS.ATTEMPTS.CANCEL(id));
}

// Passation d'examen (côté étudiant)
export function startAttempt(payload) {
    return api.post(ENDPOINTS.ATTEMPTS.START, payload);
}
export function submitAttempt(id) {
    return api.post(ENDPOINTS.ATTEMPTS.SUBMIT(id));
}
export function submitAnswer(attemptId, payload) {
    return api.post(ENDPOINTS.ATTEMPTS.ANSWERS(attemptId), { attempt_id: attemptId, ...payload });
}
// Contenu de l'examen (questions + options de réponse, sans is_correct)
export function getExamContent(attemptId) {
    return api.get(`${ENDPOINTS.ATTEMPTS.BY_ID(attemptId)}/exam-content`);
}
// Temps restant (polling léger pour resynchroniser le minuteur avec le serveur)
export function getTimeRemaining(attemptId) {
    return api.get(`${ENDPOINTS.ATTEMPTS.BY_ID(attemptId)}/time-remaining`);
}
// Heartbeat (signal de présence) - crédite automatiquement le temps perdu
// en cas de coupure de courant/connexion détectée entre deux appels.
export function sendHeartbeat(attemptId) {
    return api.post(`${ENDPOINTS.ATTEMPTS.BY_ID(attemptId)}/heartbeat`);
}
